import React, { useEffect, useState } from "react";
import {
  IgniteMainWrapper,
  BannerSection,
  BannerContent,
  BannerTitle,
  AboutWrapper,
  AboutDescription,
  AboutLeft,
  AboutRight,
  AboutSection,
  AboutTitle,
  StatBrand,
  StatItem,
  StatNumber,
  StatText,
  StatsRow,
  StatsRow1,
  CarnivalCard,
  CarnivalText,
  CarnivalTitle,
  ThunderIcon,
  VisionCard,
  VisionSection,
  VisionText,
  VisionTitle,
  ImpactCard,
  ImpactGrid,
  ImpactSection,
  ImpactTitle,
  ImpactYear,
  JoyDescription,
  JoyHeader,
  JoyLeft,
  JoyRight,
  JoyTitle,
  JoySection,
  CardIcon,
  CardIcon1,
  CardLabel,
  CardText,
  CardValue,
  SmallText,
  ObjectivesWrapper,
  Title,
  ContentGrid,
  Timeline,
  Spine,
  NodeWrapper,
  Connector,
  Dot,
  NodeContent,
  ItemTitle,
  ItemDesc,
  BottomCap,
  BannerText,
  BannerWrapper,
} from "./aboutContent.styles";
import "./AboutContent.css";
import AOS from "aos";
import "aos/dist/aos.css";

function TestimonialsContent() {
  useEffect(() => {
    const handleAOS = () => {
      if (window.innerWidth > 768) {
        AOS.init({ duration: 800 });
      } else {
        AOS.refreshHard();
        document.querySelectorAll("[data-aos]").forEach((el) => {
          el.removeAttribute("data-aos");
        });
      }
    };
    handleAOS();
    window.addEventListener("resize", handleAOS);
    return () => window.removeEventListener("resize", handleAOS);
  }, []);
  return (
    <>
      <div className="few-pages-banner-wrap">
        <img
          src={process.env.PUBLIC_URL + "/Assets/AllBanners/about-ignite-banner-latest.png"}
          alt="Ignite banner"
          className="banner-img"
        />
        <div className="few-pages-banner-box">
          <div className="few-pages-banner-content">
            <h1 className="banner-main-head">
              Your launchpad for future-ready capabilities
            </h1>
            <p className="banner-sub-text">
              Ignite brings together focused learning, guided progression, and
              visible outcomes to support continuous capability development
              across Accenture Song.
            </p>
          </div>
        </div>
      </div>
      {/* about section */}
      <div className="about-page-about-wrap">
        <div className="about-page-about-row row1" data-aos="fade-left">
          <div className="about-page-about-box">
            <h3 className="h3-head">The Ignite Program</h3>
            <p className="h3-below-text">
              Ignite is a launchpad for people across Accenture Song to build
              future-ready capabilities through learning aligned to strategic
              business priorities.
            </p>
            <p className="h3-below-text">
              The program brings together structured learning and clearly
              defined capability areas to support continuous skill development.
              Learning is presented through the Learning Carnival, where
              experiences are organized into focused Learning Hubs. These hubs
              provide a clear starting point, encourage exploration, and support
              steady progression while maintaining focus and rigor.
            </p>
            <p className="h3-below-text">
              Ignite also introduces a credit-based system to make learning
              progress visible. Credits and badges reflect sustained learning
              effort and capability development, helping individuals understand
              how skills build over time and track their progress along the way.
            </p>
            {/* <div className="course-mentor-wrap">
              <div className="course-mentor-box">
                <h4>50+</h4>
                <p>Total Course</p>
              </div>
              <div className="course-mentor-box">
                <h4>30+</h4>
                <p>Professional Mentor</p>
              </div>
            </div>
            <div className="course-mentor-wrap">
              <div className="course-mentor-box">
                <h4>10+</h4>
                <p>Available Language</p>
              </div>
              <div className="course-mentor-box">
                <h4>ATCI Song</h4>
              </div>
            </div> */}
          </div>
        </div>
        <div className="about-page-about-row row2" data-aos="fade-right">
          <div className="about-page-about-box">
            <h3 className="h3-head">Welcome to the Great Learning Carnival!</h3>
            <p className="h3-below-text">
              Your journey to excellence starts here. Complete Core Hub to
              unlock amazing specialized hubs!
            </p>
            <img
              src={
                process.env.PUBLIC_URL + "/Assets/About/about-carnival-icon.png"
              }
              alt="about-carnival-icon"
              className="about-carnival-icon"
            />
          </div>
        </div>
      </div>
      {/* our vision section */}
      <div className="our-vision-section">
        <div className="our-vision-wrap">
          <div className="our-vision-row row1" data-aos="fade-left">
            <div className="our-vision-box">
              <div className="vision-content">
                <h2 className="section-headings">Our Vision</h2>
                <p className="section-sub-text">
                  Spark the joy of learning through seamless, personalized
                  learning experiences.
                </p>
              </div>
              <div className="vision-img-box">
                <img
                  src={process.env.PUBLIC_URL + "/Assets/About/vision-img.png"}
                  alt="vision-img"
                  className="vision-img"
                />
              </div>
            </div>
          </div>
          <div className="our-vision-row row2" data-aos="fade-right">
            <div className="our-vision-box">
              <div className="vision-content">
                <h2 className="section-headings">
                  Designed for the Joy of Learning
                </h2>
                <p className="section-sub-text">
                  Ignite is designed to make learning engaging, intuitive, and
                  worth returning to. By balancing thoughtful structure with
                  flexibility, Ignite turns learning into an experience that
                  feels relevant, human, and energizing.
                </p>
              </div>
              <div className="vision-img-box">
                <img
                  src={process.env.PUBLIC_URL + "/Assets/About/design-img.png"}
                  alt="design-img"
                  className="design-img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <AboutWrapper>
        <JoySection>
          <ImpactSection>
            <h3 className="h3-head">Impact and Outcome</h3>
            <ImpactYear>FY 2025</ImpactYear>

            <ImpactGrid className="impact-outcome-row">
              <ImpactCard data-aos="fade-left" className="impact-outcome-box">
                <CardText>
                  <CardLabel>Core Hub Completion</CardLabel>
                  <CardValue>90%</CardValue>
                </CardText>

                <CardIcon
                  src={`${process.env.PUBLIC_URL}/Assets/About/foundation-icon.png`}
                  alt="foundation"
                />
              </ImpactCard>

              <ImpactCard data-aos="fade-right" className="impact-outcome-box">
                <CardText>
                  <CardLabel>Flagship Completion</CardLabel>
                  <CardValue>60%</CardValue>
                </CardText>

                <CardIcon
                  src={`${process.env.PUBLIC_URL}/Assets/About/flagship-icon.png`}
                  alt="flagship"
                />
              </ImpactCard>

              <ImpactCard data-aos="fade-left" className="impact-outcome-box">
                <CardText>
                  <CardLabel>Survey</CardLabel>
                  <CardValue>
                    4.2 <SmallText>Average Score</SmallText>
                  </CardValue>
                </CardText>

                <CardIcon
                  src={`${process.env.PUBLIC_URL}/Assets/About/survey-icon.png`}
                  alt="survey"
                />
              </ImpactCard>

              <ImpactCard data-aos="fade-right" className="impact-outcome-box">
                <CardText>
                  <CardLabel>Learning Modules</CardLabel>
                  <CardValue>452</CardValue>
                </CardText>

                <CardIcon
                  src={`${process.env.PUBLIC_URL}/Assets/About/foundation-icon.png`}
                  alt="modules"
                />
              </ImpactCard>

              <ImpactCard data-aos="fade-left" className="impact-outcome-box">
                <CardText>
                  <CardLabel>Campaign Communications</CardLabel>
                  <CardValue>100+</CardValue>
                </CardText>

                <CardIcon1
                  src={`${process.env.PUBLIC_URL}/Assets/About/communication-icon.png`}
                  alt="communication"
                />
              </ImpactCard>
            </ImpactGrid>
          </ImpactSection>
        </JoySection>

        <ObjectivesWrapper>
          <h3 className="h3-head objects-head">FY26 Objectives</h3>

          <ContentGrid>
            <Timeline className="about-timeline-row">
              <Spine className="spine-line" />

              <NodeWrapper side="left" top={0}>
                <NodeContent className="node-content-box">
                  <ItemTitle>Shaping Future Ready Talents</ItemTitle>
                  <ItemDesc>
                    Position Ignite as the premier global capability-building
                    program.
                  </ItemDesc>
                </NodeContent>
                <Dot>01</Dot>
                <Connector />
              </NodeWrapper>

              <NodeWrapper side="right" top={110}>
                <Connector />
                <Dot>02</Dot>
                <NodeContent className="node-content-box">
                  <ItemTitle>Building Future-Ready Capabilities</ItemTitle>
                  <ItemDesc>
                    Establish Capability Hubs in key and emerging domains to
                    build expertise and foster practitioner-led learning.
                  </ItemDesc>
                </NodeContent>
              </NodeWrapper>

              <NodeWrapper side="left" top={220} className="scale-impact-row">
                <NodeContent className="node-content-box">
                  <ItemTitle>Scale the Impact</ItemTitle>
                  <ItemDesc>
                    Broaden and deepen impact expanding across all levels in
                    Song ATCI and globally.
                  </ItemDesc>
                </NodeContent>
                <Dot>03</Dot>
                <Connector />
              </NodeWrapper>

              <NodeWrapper side="right" top={330} className="personalized-learning-row">
                <Connector />
                <Dot>04</Dot>
                <NodeContent className="node-content-box">
                  <ItemTitle>Personalized Learning Flexible Pathway</ItemTitle>
                  <ItemDesc>
                    Personalized learning journeys with mandatory Foundation and
                    Flagship modules and flexible elective pathways across hubs.
                  </ItemDesc>
                </NodeContent>
              </NodeWrapper>

              <NodeWrapper side="left" top={440} className="earn-credit-row">
                <NodeContent className="node-content-box">
                  <ItemTitle>Earn Credits, Build Capabilities</ItemTitle>
                  <ItemDesc>
                    Credit-based framework to recognize and track learning
                    achievements.
                  </ItemDesc>
                </NodeContent>
                <Dot>05</Dot>
                <Connector />
              </NodeWrapper>

              <NodeWrapper side="right" top={550} className="measuring-matters-row">
                <Connector />
                <Dot>06</Dot>
                <NodeContent className="node-content-box">
                  <ItemTitle>Measuring What Matters</ItemTitle>
                  <ItemDesc>
                    Impact Measurement Framework to track learning outcomes,
                    behavioural shifts, and business impact.
                  </ItemDesc>
                </NodeContent>
              </NodeWrapper>

              <BottomCap />
            </Timeline>
          </ContentGrid>
        </ObjectivesWrapper>
      </AboutWrapper>

      <BannerWrapper>
        <BannerText>
          Ignite is more than a learning platform- Its an evolving learning
          experience designed to grow with People, capabilities and Business
          needs.
        </BannerText>
      </BannerWrapper>
    </>
  );
}

export default TestimonialsContent;
